import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import logo from "../assets/pdmarketzlogo.png";
import { FiArrowUpRight, FiChevronDown, FiMenu, FiX } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP_LINK, openConsultationMail } from "../config/contact";

function Navbar() {
  const [showSticky, setShowSticky] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownScroll, setShowDropdownScroll] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const services = [
    { name: "Search Engine Optimization", path: "/seo-services-delhi-ncr" },
    { name: "PPC Advertising",                  path: "/ppc-services-delhi-ncr" },
    { name: "Social Media Marketing",            path: "/social-media-marketing-delhi-ncr" },
    { name: "Web Design & Development",         path: "/website-design-development-delhi-ncr" },
    { name: "Content Marketing",                path: "/content-marketing-services-delhi-ncr" },
    { name: "Email Marketing",                  path: "/email-marketing-services-delhi-ncr" },
    { name: "Ecommerce Marketing",              path: "/ecommerce-services-delhi-ncr" },
  ];

  const scrollToSection = (id) => {
    setMobileMenuOpen(false);
    if (location.pathname === "/") {
      const section = document.getElementById(id);
      if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  const goHome     = () => { setMobileMenuOpen(false); navigate("/"); };
  const goAbout    = () => { setMobileMenuOpen(false); navigate("/about"); };
  const goServices = () => { setMobileMenuOpen(false); navigate("/services"); };
  const goBlog     = () => { setMobileMenuOpen(false); navigate("/blog"); };
  const goContact  = () => { setMobileMenuOpen(false); navigate("/contact"); };

  useEffect(() => {
    const onScroll = () => setShowSticky(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const NavLinks = ({ onDropdownEnter, onDropdownLeave, dropdownOpen }) => (
    <ul className="nav-menu">
      <li onClick={() => scrollToSection("home")}>Home</li>
      <li onClick={goAbout}>About</li>
      <li className="nav-item-dropdown" onMouseEnter={onDropdownEnter} onMouseLeave={onDropdownLeave}>
        <span onClick={goServices}>Services <FiChevronDown /></span>
        {dropdownOpen && (
          <ul className="dropdown-menu">
            {services.map((s) => (
              <li key={s.path}>
                <Link to={s.path} className="dropdown-link" onClick={onDropdownLeave}>{s.name}</Link>
              </li>
            ))}
          </ul>
        )}
      </li>
      <li onClick={goBlog}>Blogs</li>
      <li onClick={goContact}>Contact Us</li>
    </ul>
  );

  const NavRight = () => (
    <div className="nav-right">
      <a href={WHATSAPP_LINK} className="nav-whatsapp" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
        <FaWhatsapp />
      </a>
      <button type="button" className="nav-btn desktop-only" onClick={openConsultationMail}>
        Free Consultation
        <span className="nav-btn-arrow"><FiArrowUpRight /></span>
      </button>
      <button className="mobile-menu-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
        {mobileMenuOpen ? <FiX /> : <><FiMenu /><span>MENU</span></>}
      </button>
    </div>
  );

  return (
    <>
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo"><img src={logo} alt="PD Marketz" onClick={goHome} /></div>
          <NavLinks onDropdownEnter={() => setShowDropdown(true)} onDropdownLeave={() => setShowDropdown(false)} dropdownOpen={showDropdown} />
          <NavRight />
        </div>
      </nav>

      <div className={`mobile-menu-overlay ${mobileMenuOpen ? "open" : ""}`}>
        <ul className="mobile-nav-menu">
          <li onClick={() => scrollToSection("home")}>Home</li>
          <li onClick={goAbout}>About</li>
          <li className="mobile-dropdown-item">
            <div className="mobile-dropdown-header">
              {/* Tapping "Services" text navigates to /services */}
              <span
                onClick={() => { goServices(); }}
                style={{ flex: 1, cursor: "pointer" }}
              >
                Services
              </span>
              {/* Arrow toggles the dropdown */}
              <FiChevronDown
                className={mobileDropdownOpen ? "rotate" : ""}
                onClick={(e) => { e.stopPropagation(); setMobileDropdownOpen(!mobileDropdownOpen); }}
                style={{ cursor: "pointer", padding: "4px", fontSize: "24px" }}
              />
            </div>
            <ul className={`mobile-dropdown-list ${mobileDropdownOpen ? "open" : ""}`}>
              {services.map((s) => (
                <li key={s.path}><Link to={s.path} onClick={() => setMobileMenuOpen(false)}>{s.name}</Link></li>
              ))}
              <li style={{ borderTop: "1px solid #f3f4f6", marginTop: "8px", paddingTop: "8px" }}>
                <Link to="/services" onClick={() => setMobileMenuOpen(false)} style={{ color: "#5b4cff", fontWeight: "700" }}>
                  View All Services →
                </Link>
              </li>
            </ul>
          </li>
          <li onClick={goBlog}>Blogs</li>
          <li onClick={goContact}>Contact Us</li>
          <li onClick={openConsultationMail} style={{ color: "#4f46e5", fontWeight: "700" }}>Free Consultation</li>
        </ul>
      </div>

      <nav className={`navbar-scroll ${showSticky ? "show" : ""}`}>
        <div className="nav-container">
          <div className="nav-logo"><img src={logo} alt="PD Marketz" onClick={goHome} /></div>
          <NavLinks onDropdownEnter={() => setShowDropdownScroll(true)} onDropdownLeave={() => setShowDropdownScroll(false)} dropdownOpen={showDropdownScroll} />
          <NavRight />
        </div>
      </nav>
    </>
  );
}

export default Navbar;
